import { Component, OnInit } from '@angular/core';
import { User } from "../../_models/user";
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { ApiIntegration } from "../../_services/api.integration";
//import { LocalStorageService, SessionStorageService } from "angular-web-storage";
import { environment } from "../../../environments/environment";
import { PayService } from '../../_services/pay.service';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-credits-processing',
  templateUrl: './credits-processing.component.html',
  styleUrls: ['./credits-processing.component.scss'],
})

export class CreditsProcessingComponent implements OnInit {

  amount: any;
  amountError: any;
  razorPayData: any;

  constructor(public g: Globals, private payService: PayService, public alertService: AlertService, private router: Router, private route: ActivatedRoute, private http: HttpClient, private api: ApiIntegration, public user: User) {
  }

  ngOnInit() { }
  processingPayment() { }
  typeAmount() {
    if (this.amount == '' || this.amount === null || this.amount === undefined || this.amount === 'undefined') {
      this.amountError = 'Please enter Amount';
    }
  }

  pay() {
    if (this.amount == '' || this.amount === null || this.amount === undefined || this.amount === 'undefined') {
      this.amountError = 'Please enter Amount';
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/paymentForCODOrderInRazorPay?accountOwnerId=' + this.user.accountOwnerId + '&amount=' + this.amount, null,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        this.razorPayData = data;
        if (data['code'] == 200) {
          this.alertService.success('orderId', data['message']);
          this.razorPayData = data;
          let options: any = {
            "key": environment.razorPayKey, // Enter the Key ID generated from the Dashboard
            "amount": this.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "image": "https:\/\/cdn.razorpay.com\/logos\/JmSlJFpcTpYP3H_medium.png",
            "order_id": this.razorPayData.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1,
            "theme": {
              "color": "#EE7125"
            }
          };
          options.handler = ((response: any, error: any) => {
            options.response = response;
            console.log("response::" + response);
            this.updateSuccessfulPayment(response);
          });
          const rzp1 = new this.payService.nativeWindow.Razorpay(options);
          rzp1.open();
          rzp1.on('payment.failed', (response: any) => {
            this.updateFailurePayment(response);
          });

        } else {

        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  updateSuccessfulPayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCreditTransactionForRazorPay', {
      "razorPayOrderId": response.razorpay_order_id,
      "razorPayPaymentId": response.razorpay_payment_id,
      "razorPaySignature": response.razorpay_signature,
      "response": "SUCCESS"
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.router.navigate(['/admin/credits']);
        this.alertService.success('Payment Success', data['message']);
      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  updateFailurePayment(response) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCreditTransactionForRazorPay', {
      "errorCode": response.error.code,
      "errorDescription": response.error.description,
      "errorSource": response.error.source,
      "errorReason": response.error.reason,
      "errorStep": response.error.step,
      "razorPayOrderId": response.error.metadata.order_id,
      "razorPayPaymentId": response.error.metadata.payment_id,
      "response": "FAILURE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Payment Failed', data['message']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
